import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../../@core/auth/auth.service';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';
import { Brewery } from '../models/brewery';

@Injectable({
  providedIn: 'root'
})
export class BreweryService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
    private errorService: ErrorService
  ) {
    this.basePath = environment.HOLLINGBERY_API_URL;
  }

  public getBreweryList(): Observable<Brewery[]> {
    // let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    return this.httpClient.get<Brewery[]>(`${this.basePath}/api/brewers`);
  }

  public getBrewery(breweryId: number): Observable<Brewery> {
    // let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    return this.httpClient.get<Brewery>(`${this.basePath}/api/brewers/${breweryId}`);
  }

  public postBrewery(brewery: Brewery): Observable<Brewery> {
    return this.httpClient.post<Brewery>(`${this.basePath}/api/brewers`, brewery);
  }

  public putBrewery(brewery: Brewery): Observable<Brewery> {
    return this.httpClient.put<Brewery>(`${this.basePath}/api/brewers?id=${brewery.recordId}`, brewery);
  }

  public deleteBrewery(brewery: Brewery): Observable<Brewery> {
    return this.httpClient.delete<Brewery>(`${this.basePath}/api/brewers/${brewery.recordId}`);
  }
}
